<template>
  <div>
    <form-section :title="$t('Integrations_Settings_BasicSettings')">
      <rest-form-item
        :label="$t('Integrations_Field_Name')"
        :hint="$t('Integrations_Field_Name_Description')"
        prop="name"
      >
        <el-input
          v-model="model.name"
          :placeholder="$t('Integrations_Field_Name')"
        />
      </rest-form-item>
    </form-section>

    <form-section :title="$t('Integrations_Settings_ConnectionSettings')">
      <rest-form-item
        :label="$t('Integrations_SbTech_Field_AuthenticationType')"
        prop="params.authentication_type"
      >
        <el-select v-model="model.params.authentication_type">
          <el-option
            :label="$t('Integrations_SbTech_Field_AuthenticationType_Username')"
            value="username"
          />
          <el-option
            :label="$t('Integrations_SbTech_Field_AuthenticationType_Token')"
            value="token"
          />
        </el-select>
      </rest-form-item>

      <rest-form-item
        :label="$t('Integrations_SbTech_Field_Username')"
        prop="params.username"
        v-if="legacyAuth"
      >
        <el-input
          v-model="model.params.username"
          :placeholder="$t('Integrations_SbTech_Field_Username')"
        />
      </rest-form-item>

      <rest-form-item
        :label="$t('Integrations_SbTech_Field_Password')"
        prop="params.password"
        v-if="legacyAuth"
      >
        <el-input
          v-model="model.params.password"
          :placeholder="$t('Integrations_SbTech_Field_Password')"
        />
      </rest-form-item>

      <rest-form-item
        :label="$t('Integrations_SbTech_Field_Certificate')"
        prop="params.certificate"
        v-if="!legacyAuth"
      >
        <el-input
          v-model="model.params.certificate"
          type="textarea"
          id="certificate_field"
          rows="7"
          :placeholder="$t('Integrations_SbTech_Field_Certificate_Description')"
        />
      </rest-form-item>

      <rest-form-item
        :label="$t('Integrations_SbTech_Field_SiteGroupId')"
        prop="params.site_group_id"
        v-if="!legacyAuth"
      >
        <el-input
          v-model="model.params.site_group_id"
          :placeholder="$t('Integrations_SbTech_Field_SiteGroupId')"
        />
      </rest-form-item>

      <rest-form-item
        :label="$t('Integrations_SbTech_Field_SiteId')"
        prop="params.site_id"
        v-if="!legacyAuth"
      >
        <el-input
          v-model="model.params.site_id"
          :placeholder="$t('Integrations_SbTech_Field_SiteId')"
        />
      </rest-form-item>

      <rest-form-item
        :label="$t('Integrations_SbTech_Field_BaseUrl')"
        prop="params.base_url"
        :hint="$t('Integrations_SbTech_Field_BaseUrl_Description')"
        v-if="!legacyAuth"
      >
        <el-input
          v-model="model.params.base_url"
          placeholder="https://bonusapi.sbtech.com/"
        />
      </rest-form-item>
    </form-section>
    <form-section
      :title="$t('Integrations_Settings_CustomUserID')"
      :description="$t('Integrations_Settings_CustomUserID_Description')"
    >
      <rest-form-item prop="params.id_attribute">
        <el-select
          v-model="model.params.id_attribute"
          filterable
          remote
          clearable
          :remote-method="fetchAttributesRemote"
          :placeholder="$t('Integrations_Settings_CustomUserID_Placeholder')"
          @focus="fetchAttributesRemote()"
        >
          <el-option
            v-for="(item, index) in attributes"
            :key="index"
            :label="item.name"
            :value="item.name"
          />
        </el-select>
      </rest-form-item>
    </form-section>
  </div>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import RestFormItem from '@/common/components/rest/RestFormItem'
import { projectEndpoint } from '@/core/helpers'
import RestApi from '@/core/services/RestApi'

export default {
  name: 'SbTechSettings',

  components: {
    FormSection,
    RestFormItem
  },

  props: {
    model: {
      type: Object,
      required: true
    }
  },
  created() {
    if (!this.$route.query.id) {
      const params = {
        authentication_type: 'token'
      }
      this.$set(this.model, 'params', params)
    } else if (!this.model.params.authentication_type) {
      this.$set(this.model.params, 'authentication_type', 'username')
    }

    this.fetchAttributes()
  },
  methods: {
    fetchAttributesRemote(query) {
      let params = { sort: 'title' }
      if (query !== null && query !== '') {
        params.title = query
      }

      RestApi({
        ...this.attributesEndpoint,
        params: params
      })
        .then(({ data }) => {
          this.attributes = data
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    },
    fetchAttributes() {
      RestApi(this.attributesEndpoint)
        .then(({ data }) => {
          this.attributes = data
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    }
  },
  computed: {
    attributesEndpoint() {
      let params = { sort: 'title' }
      params.attribute_profile = 1
      return projectEndpoint({
        method: 'get',
        url: `tags`,
        params: params
      })
    },
    legacyAuth() {
      return this.model.params.authentication_type === 'username'
    }
  },
  watch: {
    legacyAuth(value) {
      this.rules.params.certificate[0].required = !value
      this.rules.params.site_group_id.required = !value
      this.rules.params.site_id.required = !value
      this.rules.params.username.required = value
      this.rules.params.password.required = value
    }
  },
  data() {
    return {
      attributes: [],
      showUsernamePasswordFields: false,
      rules: {
        name: {
          required: true,
          message: this.$t('RestForm_FieldIsRequired')
        },
        params: {
          legacyAuth: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          },
          username: {
            required: false,
            message: this.$t('RestForm_FieldIsRequired')
          },
          password: {
            required: false,
            message: this.$t('RestForm_FieldIsRequired')
          },
          certificate: [
            {
              required: true,
              message: this.$t('RestForm_FieldIsRequired')
            },
            {
              pattern: /^-----BEGIN RSA PRIVATE KEY-----[A-Za-z0-9+/\s]+-----END RSA PRIVATE KEY-----\s*$/,
              message: this.$t(
                'Integrations_SbTech_Field_Certificate_PatternNotMatched'
              )
            }
          ],
          site_group_id: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          },
          site_id: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          },
          base_url: {
            required: false,
            type: 'url',
            message: this.$t('RestForm_FieldInvalidUrl')
          }
        }
      }
    }
  }
}
</script>

<style scoped>
>>> textarea#certificate_field {
  font-family: 'Courier New', Courier, monospace !important;
}
</style>



// WEBPACK FOOTER //
// src/modules/integrations/types/sbtech/SbTechSettings.vue